const ACCOUNT = '/account'
const CORPORATE = '/corporate'
export const OrganizationRoutes = {
  Account: {
    Commissions: {
      Base: `${ACCOUNT}/commissions`,
      CommissionId: (commissionId: string) => `${OrganizationRoutes.Account.Commissions.Base}/${commissionId}`,
    },
    Entities: `${ACCOUNT}/entities`,
    Network: `${ACCOUNT}/network`,
    Profile: `${ACCOUNT}/profile`,
    Slips: {
      Base: `${ACCOUNT}/slips`,
      SlipId: (slipId: string) => `${OrganizationRoutes.Account.Slips.Base}/${slipId}`,
    },
  },
  Corporate: {
    CreateMember: {
      Base: `${CORPORATE}/create-member`,
    },
    Members: {
      Base: `${CORPORATE}/members`,
      MemberId: {
        Base: (memberId: string) => `${CORPORATE}/members/${memberId}`,
        General: (memberId: string) => `${OrganizationRoutes.Corporate.Members.MemberId.Base(memberId)}/general`,
        Entities: (memberId: string) => `${OrganizationRoutes.Corporate.Members.MemberId.Base(memberId)}/entities`,
        Referrer: (memberId: string) => `${OrganizationRoutes.Corporate.Members.MemberId.Base(memberId)}/referrer`,
        Coach: (memberId: string) => `${OrganizationRoutes.Corporate.Members.MemberId.Base(memberId)}/coach`,
        Commissions: {
          Base: (memberId: string) => `${OrganizationRoutes.Corporate.Members.MemberId.Base(memberId)}/commissions`,
          CommissionId: (memberId: string, commissionId: string) => `${OrganizationRoutes.Corporate.Members.MemberId.Commissions.Base(memberId)}/${commissionId}`,
        },
        Network: (memberId: string) => `${OrganizationRoutes.Corporate.Members.MemberId.Base(memberId)}/network`,
      },
    },
    Commissions: {
      Base: `${CORPORATE}/commissions`,
      CommissionId: (commissionId: string) => `${OrganizationRoutes.Corporate.Commissions.Base}/${commissionId}`,
    },
    Cases: {
      Base: `${CORPORATE}/cases`,
      CaseId: (caseId: string) => `${OrganizationRoutes.Corporate.Cases.Base}/${caseId}`,
    },
    Entities: {
      Base: `${CORPORATE}/entities`,
      EntityId: {
        Base: (entityId: string) => `${OrganizationRoutes.Corporate.Entities.Base}/${entityId}`,
        Entity: (entityId: string) => `${OrganizationRoutes.Corporate.Entities.EntityId.Base(entityId)}/entity`,
        Members: (entityId: string) => `${OrganizationRoutes.Corporate.Entities.EntityId.Base(entityId)}/members`,
        Slips: (entityId: string) => `${OrganizationRoutes.Corporate.Entities.EntityId.Base(entityId)}/slips`,
      },
    },
    Slips: {
      Base: `${CORPORATE}/slips`,
      SlipId: (slipId: string) => `${OrganizationRoutes.Corporate.Slips.Base}/${slipId}`,
    },
  },
}

const ADMIN = '/admin'
export const AdminRoutes = {
  MLMParameters: `${ADMIN}/mlm-parameters`,
  UsersBatch: `${ADMIN}/users-batch`,
}
